import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken } from '../../GlobalStateContainer/actions'

import { store } from '../../GlobalStateContainer'


const EMULATION_MODE_USERS = false


/*
 * Users Actions
 * 
 */

export function fetchUsersList(dispatch) {
    let cmd = 'FETCH_USERS_LIST'

    if (EMULATION_ALL || EMULATION_MODE_USERS)

        dispatch(
            {
//TODO
                type: cmd + '_FULFILLED',
                payload: {
                    data: [
                        {
                            productBrickId: 1,
                            name: 'Species',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMDEX',
                            example: 'Oak'
                        },
                        {
                            productBrickId: 2,
                            name: 'Brand Name',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'INMMFG',
                            example: 'Bal'
                        },
                        {
                            productBrickId: 3,
                            name: 'Edge',
                            lastUpdatedAt: '2018-07-06T16:57:00.9',
                            sourceField: 'Rounded',
                            example: 'Rounded'
                        }
                    ]
                }
            }
        )

    else {
        execWithApiToken(dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            var url = buildRequestUrl('Users');
            axios.get(url, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchUserError(dispatch) {

    dispatch(
        {
            type: 'FETCH_USER_ERROR',
        }
    )
}

export function fetchUser(id) {
    let cmd = 'FETCH_USER'

    if (EMULATION_ALL || EMULATION_MODE_USERS)

        this.props.dispatch(
            {
//TODO
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        productBrickId: id,
                        name: 'Species',
                        lastUpdatedAt: '2018-07-06T16:57:00.9',
                        sourceField: 'INMDEX',
                        length: 4,
                        example: 'Oak',
                        values: [
                            {
                                'code': 'MBC',
                                'name': 'Merillat Basics Cabinets'
                            },
                            {
                                'code': 'GFC',
                                'name': 'Green Forrest'
                            }
                        ]
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('Users/') + id, { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function updateUser(id, user) {
    let cmd = 'UPDATE_USER'

    if (EMULATION_ALL || EMULATION_MODE_USERS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: user
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('Users/') + id, JSON.stringify(user), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )

                    // if logged in user
                    const state = store.getState();
                    if (state.oidc.user.profile.given_name == user.firstName &&
                            state.oidc.user.profile.family_name == user.lastName) {
                        dispatch(
                            {
                                type: 'SET_USER',
                                payload: {
                                    data: {
                                        user: user.userName,
                                        userFullName: user.firstName + ' ' + user.lastName,
                                        bidadmin: user.userRoles[0].assigned,
                                        sowadmin: user.userRoles[1].assigned
                                    }
                                }
                            }
                        )
                    }
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorUser(dispatch) {

    dispatch(
        {
            type: 'USER_ERROR',
        }
    )
}

// --  HISTORY --
export function fetchUserHistory(history) {
    let cmd = 'FETCH_USER_HISTORY'

    if (EMULATION_ALL || EMULATION_MODE_USERS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        page: history.pageIndex
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd,
                    payload: {
                        data: {
                            page: history.pageIndex
                        }
                    }
                }
            )

            axios.post(buildRequestUrl('Users/Users/GetChangeHistoryUsers'), JSON.stringify(history), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorUserHistory(dispatch) {

    dispatch(
        {
            type: 'USER_HISTORY_ERROR',
        }
    )
}

// -- USERS --
export function fetchUserUsers(users) {
    let cmd = 'FETCH_USER_USERS'

    if (EMULATION_ALL || EMULATION_MODE_USERS)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: {
                        page: users.id
                    }
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.post(buildRequestUrl('Users/GetUsersByDate'), JSON.stringify(users), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function errorUserUsers(dispatch) {

    dispatch(
        {
            type: 'USER_USERS_ERROR',
        }
    )
}


